import { shareReplay } from 'rxjs/operators';
import { WallItem } from 'streem-sdk-protobuf';
import { StreemError } from '../../streem_error';
import { logger } from '../../util/logger';
import { accumulateAndMapWallEvents, filterByProperty, excludeByProperty, findInGroup, } from '../wall/utils';
import { lastCreatedAt } from '../../util/rx/last_created_at';
export class GeolocationController {
    constructor(config) {
        this.config = config;
        this.requests = this.config.roomWall.itemsByType.pipe(findInGroup('artifactRequest'), accumulateAndMapWallEvents('artifactRequest'), shareReplay(1));
        this.responses = this.config.roomWall.itemsByType.pipe(findInGroup('artifact'), accumulateAndMapWallEvents('artifact'), filterByProperty('artifactType', WallItem.ArtifactType.GPS_POSITION), shareReplay(1));
        this.latestLocation = this.responses.pipe(excludeByProperty('gpsPosition', undefined), lastCreatedAt());
    }
    /**
     * Adds a geolocation request to the wall
     */
    requestGeolocation() {
        if (!this.config.context.remoteUserId || !this.config.context.remoteDeviceId) {
            const msg = 'remoteUserId and removeDeviceId are rewired for streemshot request';
            logger.error(msg);
            throw new StreemError(msg);
        }
        const artifactId = this.config.roomWall.addGeolocationRequest(this.config.context.remoteUserId, this.config.context.remoteDeviceId);
        logger.info(`Requesting geolocation from remoteUserId ${this.config.context.remoteUserId} on device ${this.config.context.remoteDeviceId}: `, artifactId);
        return artifactId;
    }
    /**
     * Adds a fulfilled geolocation to the wall
     */
    async fulfillGeolocation(gpsId, gpsRequestId) {
        if (!('geolocation' in navigator)) {
            this.errorGeolocation(gpsId, gpsRequestId);
        }
        navigator.geolocation.getCurrentPosition(async (position) => {
            let formattedAddress;
            try {
                formattedAddress = await this.reverseGeocode(position.coords.latitude, position.coords.longitude);
            }
            catch (error) {
                logger.error('failed to reverse geocode coordinates', error);
                this.errorGeolocation(gpsId, gpsRequestId);
                return;
            }
            this.addGpsResponse(gpsId, gpsRequestId, 'FULFILLED', position, formattedAddress);
        }, err => {
            const permissionDeniedCode = 1;
            if (err.code === permissionDeniedCode) {
                this.rejectGeolocation(gpsId, gpsRequestId);
            }
            else {
                this.errorGeolocation(gpsId, gpsRequestId);
            }
        }, { enableHighAccuracy: true });
    }
    errorGeolocation(gpsId, gpsRequestId) {
        this.addGpsResponse(gpsId, gpsRequestId, 'ERROR');
    }
    rejectGeolocation(gpsId, gpsRequestId) {
        this.addGpsResponse(gpsId, gpsRequestId, 'REJECTED');
    }
    addGpsResponse(gpsId, gpsRequestId, status, position, formattedAddress) {
        const gpsPosition = status === 'FULFILLED' && position
            ? {
                accuracy: position.coords.accuracy,
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
                formattedAddress: formattedAddress,
            }
            : undefined;
        const response = this.config.roomWall.addGeolocationResponse(gpsId, {
            inResponseToWallItemId: gpsRequestId,
            artifactType: WallItem.ArtifactType.GPS_POSITION,
            gpsPosition: gpsPosition,
            status: WallItem.Artifact.Status[status],
        });
        // @TODO Enable this with upcoming analytics work for CV2.
        // recordArtifactCaptured(response);
        logger.info(`added geolocation response ${response} to wall`);
    }
    async reverseGeocode(lat, lng) {
        if (GeolocationController.GoogleMapsKey === undefined) {
            throw new Error('Google Maps API key missing');
        }
        const query = new URLSearchParams();
        query.set('latlng', `${lat},${lng}`);
        query.set('key', GeolocationController.GoogleMapsKey);
        const url = `https://maps.googleapis.com/maps/api/geocode/json?` + query.toString();
        const res = await fetch(url);
        if (res.status === 200) {
            const payload = await res.json();
            if (payload.results.length) {
                return payload.results[0].formatted_address;
            }
            else {
                throw new Error('Could not find a formatted address in reverse geocode response');
            }
        }
        else {
            const body = await res.json();
            const message = body.message ?? 'APIError: ';
            throw new Error(message);
        }
    }
}
//# sourceMappingURL=geolocation_controller.js.map